module.exports = __webpack_public_path__ + "static/media/e-com_d2.69ca75e9.png";